import React, { PureComponent } from 'react';
import { Form, Select, InputNumber } from 'antd';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withActions } from 'actionware'
import * as numeral from 'numeral';

import Section from '../../components/section/section';
import Panel from '../../components/panel/panel';
import Button from '../../components/button/button';
import { moneyFormat } from '../../common/constants';
import { isLenderPortfolioApiEnabled } from '../../common/config';

import { toggleTransactionModal, transactionModalDetail, getLenders } from './transactionActions';

const Option = Select.Option;
export const money = (num, decimal = 0) => {
  if (!num) return 0;
  const splited = Number(num)
    .toFixed(decimal)
    .replace('.', ',')
    .split(',');
  let money = '';
  const numReverse = splited[0]
    .toString()
    .split('')
    .reverse()
    .join('');
  for (let i = 0; i < numReverse.length; i++)
    if (i % 3 === 0) money += `${numReverse.substr(i, 3)}.`;
  splited[0] = money
    .split('', money.length - 1)
    .reverse()
    .join('');
  return splited.join(',');
};
@connect(({
  localize,
  transaction: { showingTransactionModal, lenders, summary }
}) => ({
  translate: getTranslate(localize),
  showingTransactionModal,
  lenders,
  summary
}))

@withActions({
  toggleTransactionModal,
  transactionModalDetail,
  getLenders
})
class TransactionForm extends PureComponent {
  constructor() {
    super();
    this.state = {
      lenderSelected: null
    };
    this.submitTransaction = this.submitTransaction.bind(this);
    this.handleLenderChange = this.handleLenderChange.bind(this);
    this.checkExceededAmount = this.checkExceededAmount.bind(this);
  }

  componentWillMount() {
    this.props.getLenders();
  }

  submitTransaction(e) {
    e.preventDefault();
    const { summary, form, toggleTransactionModal, transactionModalDetail } = this.props;
    form.validateFields((err, values) => {
      if (!err) {
        if (isLenderPortfolioApiEnabled() && values.amount > summary.remaining_funding_amount) {
          console.log('exceeded');
        }
        toggleTransactionModal();
        transactionModalDetail(values)
      }
    });
  }

  handleLenderChange(lenderId) {
    this.setState({ lenderSelected: lenderId })
    this.props.setCurrentLender(lenderId);
    this.props.onLenderChange(lenderId);
  }

  checkExceededAmount = (rule, value, callback) => {
    const { form, summary } = this.props;
    const { getFieldValue } = form;
    const transactionType = getFieldValue('transactionType');
    if (isLenderPortfolioApiEnabled() && value && value > summary.remaining_funding_amount && transactionType === 'cashout') {
      callback('Jumlah Cash Out melebihi Sisa Saldo Pinjaman.')
    }
  }

  render() {
    const { form, translate, lenders, summary } = this.props;
    const { lenderSelected } = this.state;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: {
        sm: { span: 4 },
      },
      wrapperCol: {
        sm: { span: 6 },
      },
    };
    return (
      <Section className="lender-selector">
        <Panel>
          <span className="title">{translate('transaction.title')}</span>
          <span className="sub-title">{translate('transaction.subtitle')}</span>
          <Form {...formItemLayout} onSubmit={this.submitTransaction}>
            <Form.Item label={translate('transaction.lenderName')}>
              {getFieldDecorator('lender', {
                rules: [{ required: true, message: 'This field is required.' }]
              })(
                <Select
                  placeholder="Pilih Lender"
                  onChange={this.handleLenderChange}
                >
                  {lenders.map( lender => (
                    <Option value={lender.lender_id}>{lender.name}</Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            {
              lenderSelected && (!isLenderPortfolioApiEnabled() || (summary && summary.remaining_funding_amount)) &&
              [<Form.Item label={translate('transaction.transactionType')}>
                {getFieldDecorator('transactionType', {
                  rules: [{ required: true, message: 'This field is required.' }]
                })(
                  <Select
                    placeholder="Tipe Transaksi"
                  >
                    <Option value="topup">Top Up</Option>
                    <Option value="cashout">Cash Out</Option>
                  </Select>
                )}
              </Form.Item>,
              <Form.Item label={translate('transaction.transactionAmount')}>
                {getFieldDecorator('amount', {
                  rules: [
                    { required: true, message: 'This field is required.' },
                    
                  ]
                })(
                  <InputNumber
                    placeholder="Jumlah"
                    formatter={number => money(number)}
                    onChange={(a) => this.checkExceededAmount}
                    parser={value => value.split('.').join('')}
                    min={1}
                    max={10000000000000}
                  />
                )}
              </Form.Item>,
              <div className="action-footer">
                <Form.Item>
                  <Button
                    type="default"
                    htmlType="submit"
                  >
                    {translate('transaction.process')}
                  </Button>
                </Form.Item>
              </div>]
            }
          </Form>
        </Panel>
      </Section>
    );
  }
}

export default Form.create({})(TransactionForm);
